import { Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { Anouncement } from '../../models/anouncement';
import { AnouncementService } from '../../services/anouncement.service';
import { Router, ActivatedRoute } from '@angular/router';

@Component({
    selector: 'app-anouncement-detail',
    templateUrl: './anouncement-detail.component.html',
    styleUrls: ['./anouncement-detail.component.css']
})
export class AnouncementDetailComponent implements OnInit {

    ano$: Observable<Anouncement>;
    constructor(
        private activeRoute: ActivatedRoute,
        private service: AnouncementService
    ) { }

    ngOnInit() {
        this.ano$ = this.activeRoute.data.map(x => x.detail);
        // this.ano$ = this.service.getAnouncementDetail('11111');
    }
}



// WEBPACK FOOTER //
// F:/WMS/X-xiamenzhuhe-SDM234/zhuhe-234/sdm_fe/src/app/home/components/anouncement-detail/anouncement-detail.component.ts